export const documentWorkspaceTranslations = {
  de: {
    proposedFactsTitle: 'Fehlende Kundenangaben für diesen Entwurf festlegen',
    proposedFactsDescription:
      'Diese Angaben fehlen im Kundenstamm. Prüfen oder ändern Sie jeden vorgeschlagenen Wert und bestätigen Sie ihn für diesen neuen Beleg. Der Kundenstamm bleibt unverändert.',
    confirmProposedFact: 'Für diesen Beleg bestätigen',
    proposedFactsPending:
      'Vor dem Speichern müssen die vorgeschlagenen Belegwerte bestätigt werden.',
    provisionalTotals: 'Vorläufige Entwurfssummen: Preise oder Belegwerte sind noch ungeklärt.',
    maxLength: 'Höchstens {{limit}} Zeichen.',
    minLength: 'Mindestens {{limit}} Zeichen.',
    maximum: 'Der Wert darf höchstens {{limit}} betragen.',
    minimum: 'Der Wert muss mindestens {{limit}} betragen.',

    newTitles: {
      QUOTE: 'Neues Angebot',
      PURCHASE_ORDER: 'Neue Bestellung',
      ORDER: 'Neuer Auftrag',
      DELIVERY_NOTE: 'Neuer Lieferschein',
      INVOICE: 'Neue Rechnung',
      CREDIT_NOTE: 'Neue Gutschrift',
      CANCELLATION: 'Neue Stornorechnung',
    },
    moreDetails: 'Weitere Angaben',
    paymentSummary: '{{days}} Tage netto · {{discount}} % Skonto',
    customFields: 'Zusatzangaben zu diesem Beleg',
    requiredFields: 'Pflichtfelder',
    customerData: 'Übernommene Kundendaten',
    settings: 'Einstellungen',
    pdfTexts: 'Texte im Beleg / PDF',
    noTexts: 'Kein Kopf- oder Fußtext',
    internalOnly: 'Nur intern · erscheint nicht im PDF',
    attachmentsHint: 'Dateien zu diesem Beleg anzeigen oder hinzufügen',
    actions: 'Weitere Aktionen',
    send: 'Versand',
    followUps: 'Folgebelege',
    bindingActions: 'Festschreiben und Entfernen',
    deleteDraft: 'Belegentwurf löschen',
    saveFirst: 'Speichern Sie den Beleg, um Vorschau und Belegaktionen zu nutzen.',
    previewHint: 'Die Vorschau zeigt den zuletzt gespeicherten Stand.',
    taxAttention: 'Steuerentscheidung prüfen – Angaben und Begründung öffnen',
    portalAttention: 'Portalauftrag wartet auf Prüfung – zur Freigabe springen',
    saving: 'Wird gespeichert …',
    unsaved: 'Ungespeicherte Änderungen',
    saved: 'Gespeichert',
    notSaved: 'Noch nicht gespeichert',
    readOnly: 'Schreibgeschützt',
    net: 'Netto',
    taxTotal: 'Steuer',
    gross: 'Gesamt',
    invalid: 'Bitte prüfen Sie diese Eingabe.',
    discardTitle: 'Ungespeicherte Änderungen verwerfen?',
    discardDescription: 'Ihre Änderungen gehen beim Verlassen dieses Belegs verloren.',
    keepEditing: 'Weiterbearbeiten',
    discard: 'Änderungen verwerfen',
  },
  en: {
    proposedFactsTitle: 'Set the missing customer details for this draft',
    proposedFactsDescription:
      'These details are missing from the customer record. Review or change each proposed value and confirm it for this new document. The customer record remains unchanged.',
    confirmProposedFact: 'Confirm for this document',
    proposedFactsPending: 'Confirm the proposed document values before saving.',
    provisionalTotals: 'Provisional draft totals: prices or document values are still unresolved.',
    maxLength: 'At most {{limit}} characters.',
    minLength: 'At least {{limit}} characters.',
    maximum: 'The value must be at most {{limit}}.',
    minimum: 'The value must be at least {{limit}}.',

    newTitles: {
      QUOTE: 'New quote',
      PURCHASE_ORDER: 'New purchase order',
      ORDER: 'New order',
      DELIVERY_NOTE: 'New delivery note',
      INVOICE: 'New invoice',
      CREDIT_NOTE: 'New credit note',
      CANCELLATION: 'New cancellation invoice',
    },
    moreDetails: 'More details',
    paymentSummary: '{{days}} days net · {{discount}}% cash discount',
    customFields: 'Additional details for this document',
    requiredFields: 'Required fields',
    customerData: 'Saved customer information',
    settings: 'Settings',
    pdfTexts: 'Text in document / PDF',
    noTexts: 'No header or footer text',
    internalOnly: 'Internal only · not included in the PDF',
    attachmentsHint: 'View or add files for this document',
    actions: 'More actions',
    send: 'Send',
    followUps: 'Follow-up documents',
    bindingActions: 'Finalize and remove',
    deleteDraft: 'Delete draft document',
    saveFirst: 'Save the document to use the preview and document actions.',
    previewHint: 'The preview shows the last saved version.',
    taxAttention: 'Review the tax decision – open details and explanation',
    portalAttention: 'Portal order awaiting review – go to approval',
    saving: 'Saving …',
    unsaved: 'Unsaved changes',
    saved: 'Saved',
    notSaved: 'Not saved yet',
    readOnly: 'Read-only',
    net: 'Net',
    taxTotal: 'Tax',
    gross: 'Total',
    invalid: 'Please check this value.',
    discardTitle: 'Discard unsaved changes?',
    discardDescription: 'Leaving this document will discard your changes.',
    keepEditing: 'Keep editing',
    discard: 'Discard changes',
  },
  tr: {
    proposedFactsTitle: 'Bu taslak için eksik müşteri bilgilerini belirleyin',
    proposedFactsDescription:
      'Bu bilgiler müşteri kaydında eksik. Önerilen her değeri kontrol edin veya değiştirin ve bu yeni belge için onaylayın. Müşteri kaydı değişmeden kalır.',
    confirmProposedFact: 'Bu belge için onayla',
    proposedFactsPending: 'Kaydetmeden önce önerilen belge değerlerini onaylayın.',
    provisionalTotals: 'Geçici taslak toplamları: fiyatlar veya belge değerleri henüz netleşmedi.',
    maxLength: 'En fazla {{limit}} karakter.',
    minLength: 'En az {{limit}} karakter.',
    maximum: 'Değer en fazla {{limit}} olmalıdır.',
    minimum: 'Değer en az {{limit}} olmalıdır.',

    newTitles: {
      QUOTE: 'Yeni teklif',
      PURCHASE_ORDER: 'Yeni satın alma siparişi',
      ORDER: 'Yeni sipariş',
      DELIVERY_NOTE: 'Yeni irsaliye',
      INVOICE: 'Yeni fatura',
      CREDIT_NOTE: 'Yeni alacak dekontu',
      CANCELLATION: 'Yeni iptal faturası',
    },
    moreDetails: 'Diğer bilgiler',
    paymentSummary: '{{days}} gün net · %{{discount}} peşin ödeme indirimi',
    customFields: 'Bu belgeye ait ek bilgiler',
    requiredFields: 'Zorunlu alanlar',
    customerData: 'Kaydedilmiş müşteri bilgileri',
    settings: 'Ayarlar',
    pdfTexts: 'Belge / PDF metinleri',
    noTexts: 'Üst veya alt metin yok',
    internalOnly: 'Yalnızca dahili · PDF’de gösterilmez',
    attachmentsHint: 'Bu belgeye ait dosyaları görüntüleyin veya ekleyin',
    actions: 'Diğer işlemler',
    send: 'Gönderim',
    followUps: 'Sonraki belgeler',
    bindingActions: 'Kesinleştirme ve silme',
    deleteDraft: 'Belge taslağını sil',
    saveFirst: 'Önizleme ve belge işlemleri için belgeyi kaydedin.',
    previewHint: 'Önizleme son kaydedilen sürümü gösterir.',
    taxAttention: 'Vergi kararını kontrol edin – bilgileri ve gerekçeyi açın',
    portalAttention: 'Portal siparişi incelenmeyi bekliyor – onaya git',
    saving: 'Kaydediliyor …',
    unsaved: 'Kaydedilmemiş değişiklikler',
    saved: 'Kaydedildi',
    notSaved: 'Henüz kaydedilmedi',
    readOnly: 'Salt okunur',
    net: 'Net',
    taxTotal: 'Vergi',
    gross: 'Toplam',
    invalid: 'Lütfen bu değeri kontrol edin.',
    discardTitle: 'Kaydedilmemiş değişiklikler silinsin mi?',
    discardDescription: 'Bu belgeden ayrılırsanız değişiklikleriniz kaybolur.',
    keepEditing: 'Düzenlemeye devam et',
    discard: 'Değişiklikleri sil',
  },
  fr: {
    proposedFactsTitle: 'Définir les informations client manquantes pour ce brouillon',
    proposedFactsDescription:
      'Ces informations manquent dans la fiche client. Vérifiez ou modifiez chaque valeur proposée et confirmez-la pour ce nouveau document. La fiche client reste inchangée.',
    confirmProposedFact: 'Confirmer pour ce document',
    proposedFactsPending: 'Confirmez les valeurs proposées pour le document avant de sauvegarder.',
    provisionalTotals:
      'Totaux provisoires du brouillon : des prix ou des valeurs du document restent à préciser.',
    maxLength: 'Au maximum {{limit}} caractères.',
    minLength: 'Au moins {{limit}} caractères.',
    maximum: 'La valeur doit être au maximum de {{limit}}.',
    minimum: 'La valeur doit être au moins de {{limit}}.',

    newTitles: {
      QUOTE: 'Nouveau devis',
      PURCHASE_ORDER: 'Nouvelle commande fournisseur',
      ORDER: 'Nouvelle commande',
      DELIVERY_NOTE: 'Nouveau bon de livraison',
      INVOICE: 'Nouvelle facture',
      CREDIT_NOTE: 'Nouvel avoir',
      CANCELLATION: 'Nouvelle facture d’annulation',
    },
    moreDetails: 'Informations complémentaires',
    paymentSummary: '{{days}} jours nets · {{discount}} % d’escompte',
    customFields: 'Informations supplémentaires de ce document',
    requiredFields: 'Champs obligatoires',
    customerData: 'Informations client enregistrées',
    settings: 'Paramètres',
    pdfTexts: 'Textes du document / PDF',
    noTexts: 'Aucun texte d’en-tête ou de pied de page',
    internalOnly: 'Interne uniquement · absent du PDF',
    attachmentsHint: 'Afficher ou ajouter les fichiers de ce document',
    actions: 'Autres actions',
    send: 'Envoi',
    followUps: 'Documents suivants',
    bindingActions: 'Validation définitive et suppression',
    deleteDraft: 'Supprimer le brouillon',
    saveFirst: 'Enregistrez le document pour utiliser l’aperçu et les actions.',
    previewHint: 'L’aperçu affiche la dernière version enregistrée.',
    taxAttention: 'Vérifier la décision fiscale – ouvrir les détails et la justification',
    portalAttention: 'Commande du portail en attente de vérification – accéder à l’approbation',
    saving: 'Enregistrement …',
    unsaved: 'Modifications non enregistrées',
    saved: 'Enregistré',
    notSaved: 'Pas encore enregistré',
    readOnly: 'Lecture seule',
    net: 'Net',
    taxTotal: 'Taxe',
    gross: 'Total',
    invalid: 'Veuillez vérifier cette valeur.',
    discardTitle: 'Abandonner les modifications non enregistrées ?',
    discardDescription: 'Quitter ce document entraînera la perte de vos modifications.',
    keepEditing: 'Continuer la modification',
    discard: 'Abandonner les modifications',
  },
  es: {
    proposedFactsTitle: 'Definir los datos del cliente que faltan para este borrador',
    proposedFactsDescription:
      'Estos datos faltan en la ficha del cliente. Revise o cambie cada valor propuesto y confírmelo para este nuevo documento. La ficha del cliente permanece sin cambios.',
    confirmProposedFact: 'Confirmar para este documento',
    proposedFactsPending: 'Confirme los valores propuestos del documento antes de guardar.',
    provisionalTotals:
      'Totales provisionales del borrador: aún faltan precios o valores del documento por aclarar.',
    maxLength: 'Como máximo {{limit}} caracteres.',
    minLength: 'Al menos {{limit}} caracteres.',
    maximum: 'El valor máximo es {{limit}}.',
    minimum: 'El valor mínimo es {{limit}}.',

    newTitles: {
      QUOTE: 'Nuevo presupuesto',
      PURCHASE_ORDER: 'Nuevo pedido de compra',
      ORDER: 'Nuevo pedido',
      DELIVERY_NOTE: 'Nuevo albarán',
      INVOICE: 'Nueva factura',
      CREDIT_NOTE: 'Nueva nota de crédito',
      CANCELLATION: 'Nueva factura de anulación',
    },
    moreDetails: 'Más información',
    paymentSummary: '{{days}} días netos · {{discount}} % de descuento por pronto pago',
    customFields: 'Información adicional de este documento',
    requiredFields: 'Campos obligatorios',
    customerData: 'Información del cliente guardada',
    settings: 'Configuración',
    pdfTexts: 'Textos del documento / PDF',
    noTexts: 'Sin texto de cabecera ni de pie',
    internalOnly: 'Solo interno · no aparece en el PDF',
    attachmentsHint: 'Ver o añadir archivos de este documento',
    actions: 'Más acciones',
    send: 'Envío',
    followUps: 'Documentos posteriores',
    bindingActions: 'Finalizar y eliminar',
    deleteDraft: 'Eliminar borrador',
    saveFirst: 'Guarde el documento para usar la vista previa y las acciones.',
    previewHint: 'La vista previa muestra la última versión guardada.',
    taxAttention: 'Revisar la decisión fiscal – abrir detalles y justificación',
    portalAttention: 'Pedido del portal pendiente de revisión – ir a la aprobación',
    saving: 'Guardando …',
    unsaved: 'Cambios sin guardar',
    saved: 'Guardado',
    notSaved: 'Aún no guardado',
    readOnly: 'Solo lectura',
    net: 'Neto',
    taxTotal: 'Impuesto',
    gross: 'Total',
    invalid: 'Revise este valor.',
    discardTitle: '¿Descartar los cambios sin guardar?',
    discardDescription: 'Si abandona este documento, se perderán sus cambios.',
    keepEditing: 'Seguir editando',
    discard: 'Descartar cambios',
  },
} as const;
